<template>
  <vue-draggable-resizable ref="standardRef" :x="0" :y="0" class="standard" :draggable="draggable"
                           class-name="dragging1" @dragging="onDrag(x,y)">
    <div class="replaceBox" :class="{replaceBox_B: bCb_}" @mouseup="draggable = true">
      <div class="replace-head">
        <span class="title">查找替换</span>
        <i class="close-btn" @click="onClose"></i>
      </div>
      <div class="replace-main">
        <div class="replace-input">
          <div class="search-box">
            <span class="replace-title replace-text">查找</span>
            <input type="text" v-model="seekTxt_" @mousedown="draggable = false" class="i-search"
                   placeholder="请输入查找内容" />
          </div>
          <div class="replace-box">
            <span class="replace-text">替换为</span>
            <input type="text" v-model="seekTxt2_" placeholder="请输入替换内容"
                   @mousedown="draggable = false" class="i-replace" />
          </div>
        </div>
        <div class="replace-icons">
          <i class="el-icon-caret-top" @click="findPrevious"></i>
          <div class="seek-index">
            <span style="color: #4C72FF">{{ seekNum_ }}</span>/<span>{{
              seekNum2_
            }}</span>
          </div>
          <i class="el-icon-caret-bottom" @click="findNext"></i>
        </div>
      </div>
      <div class="replaceBtn">
        <!-- <button @click="onReplace">替换</button> -->
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="seekChange">查找</el-button>
        <el-button type="primary" @click="onReplace">替换</el-button>
        <el-button type="primary" class="replace" @click="replaceChange">全部替换</el-button>
        <!-- <button @click="previous">上一个</button>
        <button @click="findNext">下一个</button> -->
      </div>
    </div>
  </vue-draggable-resizable>
</template>
<script>
export default {
  name: "seek",
  props: ["seekTxt", "seekTxt2", "seekNum", "seekNum2", "bCb"],
  data() {
    return {
      x: 0,
      y: 0,
      draggable: true
    };
  },
  components: {},
  computed: {
    seekTxt_: {
      get() {
        return this.seekTxt
      },
      set(val) {
        this.$emit('onSeekTxt', val)
      }
    },
    seekTxt2_: {
      get() {
        return this.seekTxt2
      },
      set(val) {
        this.$emit('onSeekTxt2', val)
      }
    },
    seekNum_: function () {
      return this.seekNum;
    },
    seekNum2_: function () {
      return this.seekNum2;
    },
    bCb_: function () {
      return this.bCb;
    },
  },
  methods: {
    onDrag(x, y) {
      console.log(x, y)
      this.x = x;
      this.y = y;
    },
    seekChange() {
      this.$emit('seekChange')
    },
    onReplace() {
      this.$emit('onReplace')
    },
    replaceChange() {
      this.$emit('replaceChange')
    },
    findPrevious() {
      this.$emit('findPrevious')
    },
    findNext() {
      this.$emit('findNext')
    },
    onClose() {
      this.$emit('onClose')
    }
  },
};
</script>
<style lang="scss" scoped>
.standard {
  z-index: 999 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: calc(-253px / 2);
  cursor: move;
  //margin-left: calc(-570px / 2);
  //transform: translate(-50%, -50%) !important;
}

.replaceBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 570px;
  background: #ffffff;
  box-shadow: 0 0 56px 6px rgba(56, 74, 95, 0.3);
  border-radius: 4px;

  .replace-head {
    display: flex;
    justify-content: space-between;
    padding: 25px 30px 0 30px;

    .title {
      font-size: 16px;
      color: #333333;

      &::before {
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 3px;
        height: 16px;
        background: linear-gradient(0deg, #99c1ff, #3684ff);
        border-radius: 1px;
        margin-right: 7px;
      }
    }

    .close-btn {
      display: block;
      width: 15px;
      height: 15px;
      cursor: pointer;
      background: url("~@/assets/imgs/alignment-icons/button-cancel.png")
        no-repeat center;
    }
  }

  .replace-main {
    display: flex;
    padding: 30px 50px;

    .search-box {
      margin-bottom: 20px;
    }

    .replace-icons {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;
    }

    .seek-index {
      padding: 10px 0;
    }

    .el-icon-caret-top,
    .el-icon-caret-bottom {
      font-size: 25px;
      color: #bfbfbf;
      cursor: pointer;

      &:hover {
        color: #0078fc;
      }
    }

    .replace-title {
      display: inline-block;
      width: 42px;
      text-align-last: justify;
      text-align: justify;
      text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
    }

    .replace-text {
      height: 12px;
      color: #333333;
    }

    .i-search,
    .i-replace {
      width: 338px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 4px;
      outline: none;
      margin-left: 16px;
      padding: 10px;
    }
  }

  .replaceBtn {
    padding: 0px 103px 30px;
    display: flex;
    justify-content: space-between;

    .el-button {
      padding: 0;
      width: 76px;
      height: 30px;
      font-size: 14px;
      border-radius: 4px;
      color: #ffffff;
      &:nth-child(1) {
        border: 1px solid #0078fc;
        color: #0078fc;
      }
    }
  }
}
</style>
